import React from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', ...props }, ref) => {
    return (
      <input
        ref={ref}
        className={`w-full bg-fieldiq-dark border border-fieldiq-border rounded-lg px-3 py-2.5 text-white text-sm placeholder-fieldiq-muted focus:outline-none focus:border-fieldiq-accent/50 transition-colors ${className}`}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';
